import { LinkProps } from '@mui/material'
import { ExternalLink } from 'components/core/links/external-link'
import { ReactNode, useEffect, useState } from 'react'

interface DocsLinkProps extends LinkProps {
    path: string
    children: ReactNode
}

const docsDomain = 'www.conductorone.com'

// NOTE: this used to be more complex, because we injected a JWT to auth to docs: leaving the structure for now,
// because we might bring authenticated odcs back some day.
export const createURL = (path: string): string | undefined => {
    if (!path) {
        return undefined
    }
    const ux = new URL(path, `https://${docsDomain}`)
    ux.protocol = 'https'
    ux.hostname = docsDomain
    return ux.toString()
}

export const DocsLink = ({ path, children, variant = 'body1', ...extraProps }: DocsLinkProps): React.ReactElement | null => {
    const [href, setHref] = useState<string>('')

    useEffect(() => {
        const target = createURL(path)
        if (target) {
            setHref(target)
        }
    }, [path])

    if (!path) {
        return null
    }

    return (
        <ExternalLink href={href} variant={variant} {...extraProps}>
            {children}
        </ExternalLink>
    )
}
